import { EMPTY_LIST } from '../../../../constants/common'
import { ATTACH_ACTION_SELECT_ACTION_FILE } from '../../../AttachActionSelect'
import Button from '../../../Button'
import { Divider } from '../../../Divider'

import {
  FULL_SCREEN_ACTION_KEY,
  REMOVE_DRAFT_ACTION_KEY,
  REMOVE_DRAFT_DIVIDER_ACTION_KEY,
} from './EmailReplyFormMobileMoreActions.constants'

export function getEmailReplyFormMobileMoreActions({
  attachActionOptions = EMPTY_LIST,
  disabled,
  dividerClassName,
  t,
  onAttachAction,
  onMakeFormFullScreen,
  onMobileOpenFileAttach,
  onRemoveDraft,
}) {
  const attachActions = attachActionOptions.map(option => {
    if (option.value === ATTACH_ACTION_SELECT_ACTION_FILE) {
      return {
        Component: Button.Flat,
        disabled,
        isGrey: true,
        key: option.value,
        text: option.label,
        onClick: onMobileOpenFileAttach,
      }
    }

    return {
      Component: Button.Flat,
      disabled,
      isGrey: true,
      key: option.value,
      text: option.label,
      onClick: () => onAttachAction(option),
    }
  })

  const replyFormActions = []

  if (onMakeFormFullScreen) {
    replyFormActions.push({
      Component: Button.Flat,
      disabled,
      isGrey: true,
      key: FULL_SCREEN_ACTION_KEY,
      text: t('Email.ReplyFormFullScreenOptionKey'),
      onClick: onMakeFormFullScreen,
    })
  }

  if (onRemoveDraft) {
    replyFormActions.push({
      Component: Divider,
      className: dividerClassName,
      key: REMOVE_DRAFT_DIVIDER_ACTION_KEY,
    })

    replyFormActions.push({
      Component: Button.Flat,
      disabled,
      isGrey: true,
      key: REMOVE_DRAFT_ACTION_KEY,
      text: t('Email.ReplyFormRemoveDraftOptionKey'),
      onClick: onRemoveDraft,
    })
  }

  return [...attachActions, ...replyFormActions]
}
